module.exports = __webpack_public_path__ + "static/Homegroups-268dbf8f31fd1a0f2df3372df1e63d04.jpg";